export enum SelectPlanBlockType {
  selectPlan = 'select-plan',
  selectPlanWithPayment = 'select-plan-with-payment',
  singlePlanWithPayment = 'single-plan-with-payment',
  paymentModalWindow = 'payment-modal-window',
  buttonScrollToRef = 'button-scroll-to-ref',
  paymentBlock = 'payment-block',
  selectPlanScrollToRef = 'select-plan-scroll-to-ref',
  selectPlanWithPaymentForcedApplePay = 'select-plan-with-payment-forced-apple-pay',
}

export const selectPlanBlocksWithPayment: SelectPlanBlockType[] = [
  SelectPlanBlockType.selectPlanWithPayment,
  SelectPlanBlockType.singlePlanWithPayment,
]

export enum PaymentMethod {
  CARD = 'card',
  PAYPAL = 'paypal',
  APPLE_PAY = 'apple_pay',
  GOOGLE_PAY = 'google_pay',
}

export enum PaymentPlatform {
  STRIPE = 'stripe',
  PAYPAL = 'paypal',
}

export enum CheckoutFlowVersion {
  V1 = 'v1',
  V2 = 'v2',
}
